var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TooltipContainer, TooltipDiv } from "./Tooltip.style";
var Tooltip = function (_a) {
    var toolTipText = _a.toolTipText, ariaLabel = _a.ariaLabel, ariaDescribedBy = _a.ariaDescribedBy;
    return (_jsx(TooltipContainer, __assign({ "aria-label": ariaLabel, id: ariaDescribedBy, "aria-describedby": ariaDescribedBy, role: "tooltip" }, { children: _jsx(TooltipDiv, __assign({ hasBorder: false, placement: "bottom-start", isInteractive: true, content: toolTipText }, { children: _jsx(FontAwesomeIcon, { icon: faQuestionCircle, "data-testid": "tooltip-icon" }) })) })));
};
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map